import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tabela',
  templateUrl: './tabela.component.html',
  styleUrls: ['./tabela.component.scss']
})
export class TabelaComponent {
  @Input() cabecalhos: string[];
  @Input() items: any[];
  @Input() colunasOcultas: string[];
  @Input() condicoesColunas: { columnName: string; condition?: boolean }[];

  mostraOuEscondeColuna(columnName: string): boolean {
    const condition = this.condicoesColunas.find(
      (c) => c.columnName === columnName
    );
    return (
      this.colunasOcultas.includes(columnName) &&
      !(condition && condition.condition)
    );
  }
}
